export
const name: string = "LogDepth";

export
const preproc: string = ``;

export
const declaration: string = `
    uniform float   u_log_depth_buf_FC;
`;

export
const varyings: string = `
    varying float   vFragDepth;
`;

export
const implementation: string = `
    void setVaryingsForLogarithmicDepthBuffer()
    {
        if (u_log_depth_buf_FC > 0.0) {
            // the max(1e-7, ...) is originally inside the log2, but near plane clip the poorly teselated triangles so we try to get rid of
            // of negative z values which seems to help us ....
            gl_Position.z = max(1e-7, log2(gl_Position.w + 1.0) * u_log_depth_buf_FC);

            vFragDepth = 1.0 + gl_Position.w;
        }
        else {
            vFragDepth = 0.0;
        }
    }
`;
